/* The Diatomat – reveal-on-scroll + hero parallax (no dependencies). */
(() => {
  window.__dmReady = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- Reveal on scroll ---- */
  const io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-in');
                io.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
        )
      : null;

  const scan = (scope = document) => {
    scope.querySelectorAll('[data-dm-reveal]:not(.is-in)').forEach((el) => {
      if (io) io.observe(el);
      else el.classList.add('is-in');
    });
  };

  /* ---- Parallax on hero backgrounds ---- */
  let ticking = false;
  const parallax = () => {
    ticking = false;
    if (reduce.matches) return;
    document.querySelectorAll('[data-dm-parallax]').forEach((el) => {
      const box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > window.innerHeight) return;
      el.style.transform = `translate3d(0, ${(box.top * -0.12).toFixed(1)}px, 0) scale(1.02)`;
    });
  };
  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(parallax);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
    event.target.querySelectorAll('[data-dm-reveal]').forEach((el) => el.classList.add('is-in'));
    onScroll();
  });

  scan();
  parallax();
})();
